import type { DevicesLocales } from '@/types/lang/locales'
import { EDeviceActions } from '../../store/deviceStore/DeviceStoreTypes'

export const devicesEn: DevicesLocales = {
    actions: {
        deleteDevice: 'Delete device',
        deleteDeviceName: "Device's name",
        deleteDeviceNameConfirm: "Device's name to confirm",
        addDetection: {
            action: 'Manual detection',
            title: 'Add a manuel detection',
            timestamp: 'Timestamp',
            createDetectionSuccess: 'Read successfully created !'
        },
        reassignCheckpoint: 'Assign to a checkpoint',
        attachDeviceToOrganization: 'Attach to a client',
        detachDeviceToOrganization: 'Detach from a client',
        changeDeviceType: 'Change device type',
        commands: {
            arguments: 'Arguments',
            availableCommands: 'Available commands',
            commandConfig: "Command's arguments {command}",
            commandTitle: 'Send a command',
            createdAt: 'Create at',
            lastUpdate: 'Last update',
            from: 'From',
            historyText: 'Commands history',
            noAvailableCommand: 'Aucune commande disponible',
            sendCommand: 'Send command {command}'
        },
        rdrChannels: {
            rdrChannelsText:
                "This device's RFID channel is already used on this checkpoint. Would youalso like to switch channel ?"
        }
    },
    api: {
        error: {
            [EDeviceActions.CREATE_DEVICE]: 'An error occured while creating the device {name}',
            [EDeviceActions.DELETE_DEVICE]: 'An error occured while deleting the device {name}',
            [EDeviceActions.FETCH_DEVICE]: 'An error occured while fetching the device',
            [EDeviceActions.FETCH_DEVICES]: 'An error occured while fetching the devices',
            [EDeviceActions.UPDATE_DEVICE]: 'An error occured while updating the device {name}',

            [EDeviceActions.MASS_UPDATE_DEVICE]: 'Error updating all devices',
            [EDeviceActions.FETCH_API_DEVICE]: 'Error retrieving device',
            [EDeviceActions.UPDATE_API_DEVICE]: 'Error updating device',
            [EDeviceActions.GET_DEVICE_API_KEY]: 'Error retrieving API key',
            [EDeviceActions.GET_COMMANDS]: 'Error retrieving commands',
            [EDeviceActions.GET_DEVICE_COMMANDS_HISTORY]: 'Error retrieving command history',
            [EDeviceActions.SEND_DEVICE_COMMAND]: 'Error sending command',
            [EDeviceActions.REINITIALIZE_DEVICE_FLAG]: 'Error resetting ID flag',
            [EDeviceActions.CHANGE_SERIAL_NUMBER]: 'Error changing serial number'
        },
        success: {
            [EDeviceActions.CREATE_DEVICE]: 'Device {name} successfully created !',
            [EDeviceActions.DELETE_DEVICE]: 'Device {name} successfully deleted !',
            [EDeviceActions.FETCH_DEVICE]: 'Device successfully fetched',
            [EDeviceActions.FETCH_DEVICES]: 'Devices successfully fetched',
            [EDeviceActions.UPDATE_DEVICE]: 'Device {name} successfully updated !',

            [EDeviceActions.MASS_UPDATE_DEVICE]: 'Device update performed successfully!',
            [EDeviceActions.FETCH_API_DEVICE]: 'Device recovery performed successfully!',
            [EDeviceActions.UPDATE_API_DEVICE]: 'Device update completed successfully!',
            [EDeviceActions.GET_DEVICE_API_KEY]: 'API key retrieval completed successfully!',
            [EDeviceActions.GET_COMMANDS]: 'Command retrieval completed successfully! ',
            [EDeviceActions.GET_DEVICE_COMMANDS_HISTORY]:
                'Commands history retrieval successfully completed!',
            [EDeviceActions.SEND_DEVICE_COMMAND]: 'Command dispatch successfully completed! ',
            [EDeviceActions.REINITIALIZE_DEVICE_FLAG]:
                'Identification flag reset completed successfully!',
            [EDeviceActions.CHANGE_SERIAL_NUMBER]: 'Serial number change completed successfully!'
        }
    },
    buttons: {
        hideAdvanced: 'Hide advanced configuration',
        showAdvanced: 'Show advanced configuration'
    },
    configuration: {
        errors: {
            rangeError: 'Value should be between {min} and {max}',
            excludedError: "Value can't be {excluded}"
        },
        name: 'Device name',

        unknownKey: 'Unknown key',
        undefinedDescription: 'Undefined description',

        hasModificationsContent: 'Configuration has modifications :',
        hasModificationsConfirmation: 'Do you want to save ?',
        hasErrorContent: 'These fields have errors :',
        hasErrorConfirmation: 'Please correct the errors before saving'
    },
    createDevice: 'Create a device',
    detail: {
        informations: {
            actions: 'Actions',
            informationsTitle: 'Information',
            latestDetections: 'Reads',
            localization: 'Localization',
            config: 'Configuration'
        },
        configuration: {
            configurationTitle: 'Configuration',
            connectivityTitle: 'Connectivity',
            miscTitle: 'Misc'
        },
        detections: {
            detectionsTitle: 'Reads',
            table: {
                bib: 'Bib',
                checkpoint: 'Checkpoint',
                timestamp: 'Date',
                device: 'Device',
                event: 'Event',
                event_filter: 'Event filter',
                timer_filter: 'Timer filter'
            },
            liveDetections: 'Live reads',
            pastDetections: 'Previous reads'
        },
        documents: {
            documentsTitle: 'Documents'
        },
        history: {
            historyTitle: 'Configuration history',
            filters: {
                name: 'Key name'
            }
        },
        informationsTitle: 'Information'
    },
    filters: {
        checkpoint: 'Checkpoint',
        event: 'Event',
        isRented: 'Currently rented',
        lowBattery: 'Low battery',
        lowSignal: 'Low signal',
        name: 'Name',
        nameOrSerial: 'Name or serial number'
    },
    latestDetections: 'Reads',
    model: {
        apiKey: 'API key',
        checkpointName: 'Checkpoint associated',
        description: 'Description',
        deviceName: 'Device name',
        deviceType: 'Device type',
        eventName: 'Event associated',
        firmwareUpdated: 'Firmware updated',
        firmwareVersion: 'Firmware version',
        imeiSAT: 'Imei SAT',
        lastMaintenanceDate: 'Last maintenance date',
        manufactureDate: 'Manufacture date',
        organizationName: 'Owner',
        serialNumber: 'Serial number',
        simIccid: 'Sim ICCID',

        config_status: 'Configuration awaiting synchronization',
        config_synced_at: 'Last configuration synchronization'
    },
    noDetectionFound: 'No detection found',
    rental: {
        rentalApiSuccess: 'Rental successfully created !',
        rentalApiError: 'Error while creating a rental',
        action: 'Rent device',
        renterName: 'Rented to',
        rentedByEmail: 'Owner',
        title: 'Rent device to an other organization',
        rentToOrganization: 'Rent to this organization',
        startAt: 'Rental start',
        endAt: 'Rental end',
        rented: 'Currently rented',
        unavailable: 'Unavailable',
        incomingRentals: 'Incoming rentals',

        updateCurrentRentalAction: 'Update rental',
        updateCurrentRentalTitle: 'Update current rental',
        updateCurrentRentalDescription:
            'Do you really want to update the current rental ? This action is final.',
        updateRentalApiSuccess: 'Rental updated !',

        endCurrentRentalAction: 'End rental',
        endCurrentRentalTitle: 'End current rental',
        endCurrentRentalDescription:
            "Do you really want to end the current rental ? This action will remove the tenant's access to the device.",
        endRentalApiSuccess: 'Rental ended !'
    },
    rentalsHistory: {
        title: 'Rentals history',
        table: {
            rental_end_at: 'End',
            rental_start_at: 'Start',
            renter: 'Renter'
        }
    },
    status: {
        online: 'Online',
        offline: 'Offline',
        lowBattery: 'Low battery',
        lowSignal: 'Medium signal',
        warning: 'Warning',

        lastBatteryLevel: 'Last battery level known : {battery}',
        lastBatteryLevelUnknown: 'Dernier niveau de batterie inconnu',
        updateAvailable: 'Update available'
    },
    table: {
        alerts: 'Alertes',
        createDevice: 'Create a device',
        deviceType: 'Device type',
        name: 'Nom',
        currentEventTitle: 'Event associated'
    },
    title: {
        checkpointTitle: 'Checkpoint',
        eventTitle: 'Event',
        checkpointAssociatedTitle: 'Checkpoint associated',
        currentEventTitle: 'Event associated',
        noEventAssociated: 'No associated event'
    },

    reinitializeFlag: {
        buttonTitle: 'Reinitialize flag',
        dialogTitle: 'Reinitialize identification flag',
        dialogContent: 'Do you really want to reinitiliaze the identification flag of this device ?'
    },
    changeSerialNumber: {
        buttonTitle: 'Replace serial number',
        dialogTitle: 'Replace the serial number',
        dialogContent: 'New serial number for this device '
    },
    updateVersion: {
        buttonTitle: 'Version update',
        updateTitle: "Update devices' version",

        cancelStep: 'Cancel',
        previousStep: 'Previous',
        nextStep: 'Next',
        updateStep: 'Update now',

        stepOne: {
            title: 'Update device :',
            firstLine: 'You are starting the update process of a device.',
            secondLine: 'We recommand a few things :',

            firstRule: 'Device is online',
            secondRule: 'Device is not rented and next to you',
            thirdRule: 'Device has more than 50% of battery remaining',
            fourthRule: 'We do not recommend updating equipment while it is in use on an event.',
            fifthRule: "Don't remove the battery during update"
        },

        stepTwo: {
            title: 'Update {name} :',
            battery: 'Battery {battery}%',
            notAffected: 'Not affected to an event',
            notRented: 'Not rented',

            versionSelection: 'Version to apply :',
            version: 'Version {version}',
            priority: '(Version to be installed first)'
        }
    },

    versionHistory: {
        title: "Versions' history",

        table: {
            lastVersion: 'Last version',
            sentVersion: 'Sent version',
            sentDate: 'Sent date',
            user: 'User',
            progress: 'Progress'
        }
    }
}
